import Http from "./http";

export const getTermsAndConditionsDetailsAPI = (payload) => {
  return Http.post("admin/campaign/terms-condition/get", payload);
};

